<template>
  <tg-button
    round
    border
    :theme="theme"
    :disabled="disabled"
    @click.native="handleClick"
    >{{ label }}</tg-button
  >
</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
  components: {
    TgButton,
  },
  props: {
    action: String,
    blocked: {
      type: [Number, String],
      default: 0,
    },
    targetName: String,
    isAll: Boolean,
    disabled: Boolean,
    text: String,
  },
  computed: {
    prefix() {
      let stackIndex = this.isAll ? "[1]" : "[0]";
      return this.$t("enum.stack" + stackIndex);
    },
    label() {
      if (this.text) {
        return this.text;
      }
      let index = this.blocked == 0 ? 1 : 0;
      let langKey = "enum.blocked[" + index + "]";

      return this.prefix + this.$t(langKey);
    },
    theme() {
      if (!this.isAll) {
        return "";
      }

      return this.blocked == 0 ? "danger" : "success";
    },
  },
  methods: {
    handleClick() {
      this.$emit(
        "on-click",
        this.action,
        this.blocked == 0 ? 1 : 0,
        this.targetName,
        this.isAll
      );
    },
  },
};
</script>
